// Generated by scripts/styles/generate-public-styles.mjs. Do not edit.
export const publicStylesHref = "/styles/public.4416a68b31669279.css"
export const articleStylesHref = "/styles/article-critical.969ea6409e2b4a1d.css"
export const productStylesHref = "/styles/product-critical.d45348d8f8947851.css"
export const compareStylesHref = "/styles/compare-critical.793597a3a5bdecad.css"
